import { FaSolidSpinner } from 'solid-icons/fa'
import { Component } from 'solid-js'

const LoadingIcon: Component = () => {
  return <FaSolidSpinner class="fa-spin-pulse" />
}

export default LoadingIcon